import type { DiagnosticActivity } from "@/services/api/odin/activities/diagnostic/study-session/update"
import MultipleChoiceForm from "./multiple-choice-form"
import AnalysisForm from "./analysis-form"
import { Dialog, DialogContent, DialogTrigger } from "@/components/ui/dialog"
import { Button } from "@/components/ui/button"
import { SquarePen } from "lucide-react"
import { useState } from "react"

interface UpdateDiagnosticModalProps {
  activity: DiagnosticActivity
  setActivity: React.Dispatch<React.SetStateAction<DiagnosticActivity>>
}

export default function UpdateDiagnosticModal({
  activity,
  setActivity,
}: UpdateDiagnosticModalProps) {
  const [isOpen, setIsOpen] = useState(false)

  function onUpdateActivity(question: string, options?: string[], answer?: string) {
    if (activity.next.questionType === "multiple_choice") {
      setActivity({
        ...activity,
        next: {
          ...activity.next,
          question,
          options: options ?? activity.next.options,
        },
      })
      return
    }

    if (activity.next.questionType === "analysis" || activity.next.questionType === "open_ended") {
      setActivity({
        ...activity,
        next: { ...activity.next, question, answer: answer ?? activity.next.answer },
      })
      return
    }
  }

  return (
    <Dialog open={isOpen} onOpenChange={setIsOpen}>
      <DialogTrigger asChild>
        <Button variant="link" size="sm" className="self-end text-primary-500 hover:no-underline">
          <SquarePen />
          Editar
        </Button>
      </DialogTrigger>
      <DialogContent className="rounded-lg px-0">
        {activity.next.questionType === "multiple_choice" && (
          <MultipleChoiceForm
            activity={activity}
            onUpdateActivity={onUpdateActivity}
            onClose={() => setIsOpen(false)}
          />
        )}
        {(activity.next.questionType === "analysis" ||
          activity.next.questionType === "open_ended") && (
          <AnalysisForm
            activity={activity}
            onUpdateActivity={onUpdateActivity}
            onClose={() => setIsOpen(false)}
          />
        )}
      </DialogContent>
    </Dialog>
  )
}
